import styled from 'styled-components/macro';

export const StyledParticipationBudget = styled.div`
  display: flex;
  flex-direction: column;
`;
